import React from 'react';
import { Row, Col, Container } from "react-bootstrap";
// import clickHerePatch from "../img/header/btn750Credit.png";
import '../css/Banner.css'

const Banner = () => {
    return (
        <Container fluid className="banner_container">
            <Row >
                <Col xs={12}>
                    <h1 className="banner-title">
                        Kickin' Cancer
                    </h1>
                </Col>

                <Col xs={12} className='mb-4'>
                    <h3 className="banner-subtitle">
                        Thank you for serving our community.<br />
                        Now, it's our turn to serve you!
                    </h3>
                </Col>
                <Col xs={9} sm={6} md={5} lg={4} xl={3} className="text-center pb-5">
                    <a href="https://www.swmc.com/ApplyNow/" className='btnCredit btn btn-primary btn-lg' target="_blank" rel="noopener noreferrer">
                        {/* <Image src={clickHerePatch} fluid alt='A button' /> */}
                        Apply Now
                    </a>
                </Col>                       
            </Row>
        </Container>
    );
}

export default Banner;